import React from 'react';
import { motion } from 'framer-motion';
export const Hero = () => {
  const scrollToForm = () => {
    document.getElementById('booking-form')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="w-full bg-be-navy-gradient pt-12 pb-16 sm:pt-16 sm:pb-20 px-6 sm:px-10 relative overflow-hidden" data-id="element-136">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-137">
        {/* Pink underline accent */}
        <motion.div initial={{
        width: 0
      }} animate={{
        width: '56px'
      }} transition={{
        duration: 0.6
      }} className="h-px bg-be-pink mb-5" data-id="element-138" />

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="text-be-pink text-xs sm:text-sm font-semibold tracking-[0.3em] uppercase mb-4" data-id="element-139">
          This Week Only
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2,
        duration: 0.6
      }} className="mb-2" data-id="element-140">
          <h1 className="text-white font-black uppercase leading-[0.95] tracking-tight text-5xl sm:text-7xl md:text-[88px]" data-id="element-141">
            First-Visit
          </h1>
          <h1 className="font-serif italic text-be-pink-light leading-[0.95] text-6xl sm:text-7xl md:text-[96px] -mt-1" data-id="element-142">
            Reset<span className="text-be-pink" data-id="element-143">.</span>
          </h1>
        </motion.div>

        {/* Horizontal divider */}
        <motion.div initial={{
        scaleX: 0
      }} animate={{
        scaleX: 1
      }} transition={{
        delay: 0.5,
        duration: 0.6
      }} className="h-px bg-white/15 my-8 origin-left" data-id="element-144" />

        {/* $150 Credit visual */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4
      }} className="flex items-center gap-4 sm:gap-6 mb-8" data-id="element-145">
          <div className="flex items-start text-be-pink font-black leading-none" data-id="element-146">
            <span className="text-3xl sm:text-4xl md:text-5xl mt-3 sm:mt-5" data-id="element-147">
              $
            </span>
            <span className="text-7xl sm:text-8xl md:text-[140px] tracking-tighter" data-id="element-148">
              150
            </span>
          </div>
          <div className="border-l border-white/15 pl-4 sm:pl-6 py-2" data-id="element-149">
            <p className="text-white font-bold tracking-[0.25em] uppercase text-base sm:text-lg mb-2" data-id="element-150">
              Credit
            </p>
            <p className="text-white/60 text-xs sm:text-sm tracking-[0.15em] uppercase leading-relaxed" data-id="element-151">
              Toward your first
              <br data-id="element-152" />
              treatment of the year
            </p>
          </div>
        </motion.div>

        {/* Body copy */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="space-y-5 mb-8" data-id="element-153">
          <p className="text-white text-base sm:text-lg leading-relaxed" data-id="element-154">
            <span className="font-bold" data-id="element-155">You've had us bookmarked.</span>{' '}
            <span className="text-white/85" data-id="element-156">
              Book a complimentary skin consultation this week and the credit is
              yours.
            </span>
          </p>
          <p className="text-white/70 text-sm sm:text-base leading-relaxed" data-id="element-157">
            No pressure. No commitment beyond showing up. Our team maps out what
            your skin actually needs, then the credit applies to any treatment
            you book from that visit.
          </p>
        </motion.div>

        {/* Outlined expiry pill */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="inline-block border border-be-pink/60 rounded-sm px-5 py-3 mb-8" data-id="element-158">
          <p className="text-be-pink font-semibold tracking-[0.25em] text-[11px] sm:text-xs uppercase" data-id="element-159">
            Offer expires Sunday at midnight
          </p>
        </motion.div>

        {/* Full-width pink CTA */}
        <motion.button initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} whileHover={{
        scale: 1.01
      }} whileTap={{
        scale: 0.99
      }} onClick={scrollToForm} className="w-full bg-be-pink hover:bg-be-pink-light text-white py-5 sm:py-6 px-8 font-bold tracking-[0.2em] uppercase text-sm sm:text-base transition-colors shadow-lg shadow-be-pink/20" data-id="element-160">
          Book Your Consultation
        </motion.button>

        {/* Closing pink accent */}
        <div className="flex justify-end mt-4" data-id="element-161">
          <div className="h-px bg-be-pink w-14" data-id="element-162"></div>
        </div>
      </div>
    </section>;
};